import banner from '@/assets/img/solution/medical/banner.jpg'
import advantageBanner from '@/assets/img/solution/medical/advantage-banner.jpg'
import image_1 from '@/assets/img/solution/info-1.png'
import image_2 from '@/assets/img/solution/info-2.png'
import image_3 from '@/assets/img/solution/info-3.png'
import image_4 from '@/assets/img/solution/info-4.png'
import image_5 from '@/assets/img/solution/info-5.png'
import image_6 from '@/assets/img/solution/info-6.png'
import footerBanner from '@/assets/img/solution/medical/footer-banner.jpg'
import { SolutionMedicalProps } from '../type'

export const solution_medical: SolutionMedicalProps = {
  id: 1,
  path: '/solution/medical-solution',
  title: 'Medical Renewable Energy Solution',
  subTitle: 'SGIP High Incentive Projects',
  description:
    'Carus Medical provides solar PV and ESS solutions for medical facilities, lowering energy costs, ensuring backup power, and enhancing sustainability and resilience.',
  banner: banner,
  policy: {
    title: 'Subsidy Policies',
    description: `<b>ITC 30%, SGIP $180/kwh</b>(General Market Category), <br/> <b>SGIP 85% or 100%</b> (Equity & Equity Resiliency)`,
    items: [
      {
        title: 'ITC 30%',
        description:
          'offering a tax credit of 30% the total investment amount of PV ESS system; If the project is located in an Energy Community area, the ITC credit can increase to 50%.',
      },
      {
        title: 'SGIP Equity & Equity Resiliency',
        description:
          'provides subsidies for energy storage system projects in vulnerable communities, low-income communities, and high-fire risk areas, covering 85% to 100% of the overall project cost.',
      },
    ],
  },
  projects: {
    title: 'Carus Medical System Projects',
    items: [
      {
        title: 'EPC (Engineering & Procurement & Commissioning) Company',
        descriptions: ['Provide overall turnkey solution'],
        image: image_1,
      },
      {
        title: 'LFP ( Lithium lron Phosphate) Battery in All Product Line',
        descriptions: ['Tesla only employs LFP battery in Megapack'],
        image: image_2,
      },
      {
        title: 'Smaller Energy Storage Unit Modules',
        descriptions: ['5 kWh, 100 kwh, 326 kWh, 2 MWh,4 Mwh, prevent wasted investment.'],
        image: image_3,
      },
      {
        title: 'Wide Range of Product Offering Fit All Commercial Needs',
        descriptions: ['Tesla do not provide 100Mwh-200MWh'],
        image: image_4,
      },
      {
        title: 'Competitive Cost for Overall Systemlmplementation',
        descriptions: ["The average EPC total cost is at least 20% lower than Tesla's"],
        image: image_5,
      },
      {
        title: 'Superior Operation & Maintenance (0&M) Services',
        descriptions: [
          '24/7 support with local service centers',
          'Transparent SLAs ensuring clear service commitments',
        ],
        image: image_6,
      },
    ],
  },
  benefits: {
    title: 'Key Benefits from PV & ESS system',
    items: [
      {
        icon: 'economic',
        title: 'Lower Energy Costs',
      },
      {
        icon: 'reliability',
        title: 'Improved Energy Reliability and Independence',
      },
      {
        icon: 'sustainability',
        title: 'Sustainability and ESG Compliance',
      },
      {
        icon: 'enhanced',
        title: 'Enhanced Medical Resilience',
      },
    ],
  },
  tabTitle: 'PV& ESS Solution',
  tabs: [
    {
      title: 'Clinic',
      icon: 'clinic',
      tableData: [
        ['Clinic Type', 'Small Clinic', 'Medium Clinic', 'Medium Urgent Care Center'],
        ['Size (sq ft)', '2,000 - 5,000', '5,000 - 10,000', '10,000 - 15,000'],
        ['Daily Electricity Consumption (kWh/day)', '50 - 300', '300 - 800', '800 - 2,000'],
        ['Recommended Solar Capacity (kW)', '10 - 50', '50 - 150', '150 - 400'],
        ['Recommended Storage (kWh)', '20 - 100', '100 - 300', '300 - 800'],
        [
          'Remarks',
          'Covers lighting, office equipment, basic medical devices',
          'Supports HVAC, X-ray, lab equipment',
          'Suitable for 24/7 operation, higher energy demand',
        ],
      ],
    },
    {
      title: 'Hospital',
      icon: 'hospital',
      tableData: [
        ['Hospital Type', 'Small Hospital', 'Medium Hospital', 'Large Hospital'],
        ['Number of Beds', '<100', '100-300', '>300'],
        ['Daily ElectricityConsumption (kWh/day)', '2,000-10,000', '10.000-50.000', '50.000-200.000'],
        ['Recommended Solar Capacity(Mw)', '0.5-2', '2-10', '10-40'],
        ['Recommended Storage(MWh)', '1-5', '5-20', '20-80'],
        [
          'Remarks',
          'Suitable for community hospitals, covering basic medical and emergency needs',
          'Supports OR, lCU, imaging centers, high power medical devices',
          'General hospital with multiple departments and 24/7 operation',
        ],
      ],
    },
    {
      title: 'Medium & Large Hospital',
      icon: 'largeHospital',
      tableData: [
        ['Hospital Type', 'Medium Hospital', 'Large Hospital'],
        ['Number of Beds', '100-300', '>300'],
        ['Daily ElectricityConsumption (kWh/day)', '10.000-50.000', '50.000-200.000'],
        ['Recommended Solar Capacity(Mw)', '2-10', '10-40'],
        ['Recommended Storage(MWh)', '5-20', '20-80'],
        [
          'Remarks',
          'Supports OR, lCU, imaging centers, high power medical devices',
          'General hospital with multiple departments and 24/7 operation',
        ],
      ],
    },
  ],
  advantages: {
    title: 'Advantages of Our Solutions',
    image: advantageBanner,
    items: [
      {
        title: 'Distributed solutions',
        descriptions: [
          'Systems ranging from 60kWh to 652kWh, offering scalablecascade distributed designs',
          'End-to-end Delivery Model, from design to implementation.ensuring seamless project execution',
        ],
        image: advantageBanner,
      },
      {
        title: 'Flexible Configuration',
        descriptions: ['modular and scalable systemarchitecture to meet the energy needs of various scenarios'],
        image: advantageBanner,
      },
      {
        title: 'Intelligent Management Platform',
        descriptions: ['Remotely monitor power usageand optimize system efficiency with intelligent control'],
        image: advantageBanner,
      },
      {
        title: 'Subsidies & Incentives Application Support',
        descriptions: [
          'Provide end-to-endsupport for ITC and SGlP subsidy applications, ensuring customers secure and maximize their financial benefits.',
        ],
        image: advantageBanner,
      },
    ],
  },
  footer: {
    banner: footerBanner,
  },
}
